function About() {
    return (
        <>
            <div id="chisiamo">
                <p className="display-6 about-title title fw-semibold" style={{ fontSize: "30px" }}>CHI SIAMO</p>
                <p className="fs-4 text about-content">
                    {/* https://www.gentesalese.com/2014/12/26/dicembre-2014/ */}
                    L'impresa, fondata negli anni '60 da nostro padre Carlo Paolo Pagotto, é stata portata avanti da Giampietro e Sandro Pagotto.
                    Nostro padre, da giovane, cominció l'impresa edile costruendo abitazioni nella zona di S.M. di Sala e successivamente ci insegnó il suo lavoro.
                    Nel 1958 cominciammo a lavorare indipendentemente e costruire/ristrutturare
                    edifici anche nel Miranese e nel Padovano.
                    Restauriamo chiese ed edifici storici (ad esemipio la Chiesa di Caselle de' Ruffi e la Chiesetta di Villa Ferraccini).
                    Realizziamo principalmente edifici residenziali.
                </p>
            </div>
        </>
    );

}

export default About;
